import onGetCarePlanIcd10Codes from './onGetCarePlanIcd10Codes';
import onCreateCarePlanIcd10Codes from './onCreateCarePlanIcd10Codes';
import onUpdateCarePlanIcd10Code from './onUpdateCarePlanIcd10Code';
import onRemoveCarePlanIcd10Code from './onRemoveCarePlanIcd10Code';

export default {
  onGetCarePlanIcd10Codes,
  onCreateCarePlanIcd10Codes,
  onUpdateCarePlanIcd10Code,
  onRemoveCarePlanIcd10Code,
};
